import { hashMergeProperties } from './hashMergeProperties.js';

const json = {
    hashMergeProperties
};

export { json };
